<template>
  <div class="cusp-height">
    <svg :width="width" :height="height" :viewbox="viewbox">
      <g v-if="r && ae">
        <circle v-for="c in circles" v-bind:key="c.$index"
          :cx="c.x"
          :cy="c.y"
          :r="c.r"
          fill="#000"
          fill-opacity="0.02"
          stroke="#000"
          stroke-opacity="0.1"/>
        <path
          :d="path_geometry"
          stroke="black"
          stroke-width="2"
          fill="none"/>
      </g>
      <g v-if="ap">
        <path
          :d="path_ap"
          stroke="blue"
          stroke-dasharray="5,5"
          stroke-width="1"
          fill="none"/>
      </g>
    </svg>
  </div>
</template>

<style lang="scss">
.cusp-height {
  display: flex;
  padding: 20px;
  width: 100%;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import CuttingParameters from '@/lib/cutting-parameters.js';

export default {
  name: 'cusp-height',
  data: function () {
    return {
      width: 500,
      height: 150,
      count: 3,
      space: {
        bottom: 100
      }
    };
  },
  props: ['r', 'ap', 'ae'],
  computed: {
    circles: function () {
      let cs = [];
      for(let i = 0; i <= this.arcs; ++i) {
        let k = i - this.arcs / 2;
        cs.push({
          x: this.center.x + this.ae * k / this.f,
          y: this.center.y - this.r / this.f,
          r: this.r / this.f
        });
      }
      return cs;
    },
    d_eff: function () {
      return CuttingParameters.calc.d_eff(2*this.r, this.r, this.Rz);
    },
    Rz: function () {
      let cp = new CuttingParameters(this.r, this.ae, 0, this.ap);
      return cp.Rz;
    },
    arcs: function () {
      return Math.ceil(this.count * 2 * this.r / this.ae);
    },
    angleRz: function () {
      let cp = new CuttingParameters(this.r, this.ae, 0, this.ap);
      return cp.thetaH;
    },
    f: function () {
      return this.arcs * this.ae / this.width;
    },
    center: function () {
      return {x: this.width / 2, y: this.height / 2};
    },
    viewbox: function () {
      return [0, 0, this.width, this.height].join(' ');
    },
    path_ap: function () {
      let path = [];

      let c = this.center;
      let p1 = {x: -this.width/2 * 1.5, y: this.ap / this.f};
      let p2 = {x:  this.width/2 * 1.5, y: this.ap / this.f};

      path.push('M', c.x + p1.x, c.y - p1.y);
      path.push('L', c.x + p2.x, c.y - p2.y);

      return path.join(' ');
    },
    path_geometry: function () {
      let path = [];
      let c = this.center;
      let a = this.angleRz*180/Math.PI;
      for(let i = 0; i <= this.arcs; ++i) {
        let k = i - this.arcs / 2;
        path.push('M', c.x + (this.ae * k - this.d_eff/2) / this.f, c.y - this.Rz / this.f);
        path.push('A',
          this.r / this.f, this.r / this.f,
          a,
          0, 0,
          c.x + (this.ae * k) / this.f , c.y - 0);
        path.push('A',
          this.r / this.f, this.r / this.f,
          a,
          0, 0,
          c.x + (this.ae * k + this.d_eff/2) / this.f , c.y - this.Rz / this.f);
      }

      return path.join(' ');
    },
  },
  methods: {
  },
}
</script>
